// extracted by mini-css-extract-plugin
export default {"Icon-default":"theme-default_Icon-default__0gi74"};